import React, { useState, useEffect } from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
} from '@ey-xd/motif-react';

interface SessionPopupProps {
  isModalVisible: boolean;
  setModalVisibility: (isVisible: boolean) => void;
  handleLogout: () => void;
  handleExtend: () => void;
  warningTime: number;
}

function SessionPopup({
  warningTime,
  isModalVisible,
  setModalVisibility,
  handleLogout,
  handleExtend,
}: SessionPopupProps) {
  const [time, setTime] = useState(warningTime); // initial time in seconds
  const [messageTime, setMessageTime] = useState(warningTime); // initial time in seconds

  useEffect(() => {
    setTime(warningTime);
  }, [handleExtend]);
  
  useEffect(() => {
    let timer: number;
    if (isModalVisible) {
      timer = window.setInterval(() => {
        setMessageTime((prevTime) => Math.max(prevTime - 1, 0));
      }, 1000);
    }
    return () => window.clearInterval(timer);
  }, [isModalVisible]);

  useEffect(() => {
    if (messageTime <= 0) {
      handleLogout();
      setModalVisibility(false);
    }
  }, [messageTime]);

  useEffect(() => {  
    setMessageTime(time);
  }, []);

  const displayedTime =
    time > 60
      ? `${Math.floor(messageTime / 60)} minutes ${messageTime % 60} seconds`
      : `${messageTime} seconds`;

  return (
    <MotifModal
      show={isModalVisible}
      onClose={() => {
        setModalVisibility(false);
        sessionStorage.setItem('popupDismissed', 'true');
      }}
    >
      <MotifModalHeader>Your session expires soon!</MotifModalHeader>
      <MotifModalBody>
        <p>
          To keep your data safe, we will log you out of the application in{' '}
          {displayedTime}.
        </p>
        <p>
          If you are still working, you can extend your session now. Otherwise,
          you will be logged out automatically.
        </p>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          size="medium"
          type="button"
          onClick={() => {
            handleExtend();
            setModalVisibility(false);
          }}
        >
          Extend session
        </MotifButton>
        <MotifButton
          size="medium"
          variant="secondary"
          type="button"
          onClick={() => {
            handleLogout();
            setModalVisibility(false);
          }}
        >
          Log out now
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
}

export default SessionPopup;
